import { ChangeDetectionStrategy, Component, input, InputSignal } from '@angular/core';
import { EnViewportSize } from '@core/api/enums/viewport-sizes.enums';
import { LargeCardImports } from '@shared/card/large-card/large-card.imports';

@Component({
  selector: 'noda-large-card',
  standalone: true,
  templateUrl: './large-card.component.html',
  styleUrls: ['./large-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: LargeCardImports,
})
export class LargeCardComponent {
  public reverse: InputSignal<boolean> = input<boolean>(false);
  public mediaMinWidth: InputSignal<EnViewportSize> = input<EnViewportSize>(EnViewportSize.LG);
  public mediaMaxWidth: InputSignal<EnViewportSize> = input<EnViewportSize>(
    EnViewportSize.LG - 0.02,
  );
}
